import { DynamicFilterGroupConfig } from 'config/clients/configs/configCommons'

export interface DynamicFilterGroupBucket {
  label: string
  values: (string | number)[]
}

const DEFAULT_CATEGORIES = ['promoters', 'passives', 'detractors']
const DEFAULT_CATEGORIES_LABEL = ['Promotores', 'Neutros', 'Detractores']

// Rangos default para escalas 0-10 (rating estándar) y 0-5.
const NPS_10_RANGES: Record<string, (string | number)[]> = {
  promoters: [9, 10],
  passives: [7, 8],
  detractors: [0, 1, 2, 3, 4, 5, 6],
}

const NPS_5_RANGES: Record<string, (string | number)[]> = {
  promoters: [4, 5],
  passives: [3],
  detractors: [0, 1, 2],
}

const getDefaultRanges = (formula: DynamicFilterGroupConfig['formula']): Record<string, (string | number)[]> => {
  if (formula === 'nps-5') {
    return NPS_5_RANGES
  }

  if (formula === 'nps-10') {
    return NPS_10_RANGES
  }

  return {}
}

export const getDynamicFilterGroupBuckets = (config: DynamicFilterGroupConfig): DynamicFilterGroupBucket[] => {
  const categories = config.categories ?? DEFAULT_CATEGORIES
  const categoriesLabel = config.categoriesLabel ?? DEFAULT_CATEGORIES_LABEL
  const ranges = { ...getDefaultRanges(config.formula), ...(config.ranges ?? {}), }

  return categories
    .map((category, idx) => ({
      label: categoriesLabel[idx] ?? category,
      values: ranges[category] ?? [],
    }))
    .filter((bucket) => bucket.values.length > 0)
}

// Expande la(s) label(s) elegidas por el usuario (ej. 'Promotores') a los valores
// crudos que espera el backend (ej. [9, 10]) usando los buckets ya calculados.
export const expandDynamicFilterGroupValues = (
  selected: string | string[] | number | number[] | undefined,
  buckets: DynamicFilterGroupBucket[]
): (string | number)[] => {
  if (selected === undefined || selected === null) {
    return []
  }

  const selectedLabels = Array.isArray(selected) ? selected : [selected]

  return selectedLabels
    .flatMap((label) => buckets.find((bucket) => bucket.label === label)?.values ?? [])
}
